import type { ToneOverlay } from "../index.js";

// Veu "dark" en català: ironia seca, sornegueria i un punt absurd — humor propi, no una
// traducció. Opcional; la veu seriosa continua sent la predeterminada. Les línies amb
// variants roten cada dues hores (TONE_ROTATE_MS). Cada variant conserva els {marcadors}
// de la base (ho verifica tone-guardrail.test.ts).
export const overlay: ToneOverlay = {
  "alert.toast.new": [
    "{hazard} a prop. Només faltava.",
    "{hazard} a prop. Doncs ja hi som.",
    "{hazard} a prop. Apa, a passar-ho bé.",
    "{hazard} a prop. Avisa el grup.",
    "{hazard} a prop. Que bé, mira.",
  ],
  "alert.toast.escalation": [
    "El {hazard} ha anat a pitjor. Com no.",
    "El {hazard} puja. Doncs cap a pitjor.",
    "El {hazard} a més. Sol no millora, eh.",
    "El {hazard} es ve amunt. Quina il·lusió.",
  ],
  "alert.toast.inPath": [
    "El {hazard} ve a per tu. Personalment. Corre.",
    "El {hazard} t'ha agafat estima. Fuig.",
    "El {hazard} va directe a tu. Avui no, gràcies.",
    "El {hazard} amb nom i cognoms: el teu. Toca el dos.",
  ],
  "alert.toast.allClear": [
    "Encara viu prop de {place}. Alguna cosa és.",
    "{place} no t'ha enxampat. Per aquest cop.",
    "Has sobreviscut a {place}. Apunta-t'ho.",
    "Tot en calma prop de {place}. Fins la propera.",
  ],
  "alert.toast.tap": [
    "Toca per al pla de no dinyar-la.",
    "Toca, que aquí hi ha com seguir viu.",
    "Toca. Les instruccions de respirar, dins.",
  ],
  "alert.takeover.title": [
    "{hazard} — avui et toca ser protagonista. Au.",
    "{hazard} — la part de córrer de la peli. Corre.",
    "{hazard} — actua ja, les queixes després.",
  ],
  "alert.takeover.details": "Els detalls, amb el seu morbo",
  "alert.takeover.dismiss": "Sobreviscut, tancar",
  "now.status.allClear": [
    "Encara aquí. Mira.",
    "Encara respirant. Apa.",
    "Estadísticament, bé.",
    "Tranquil. Sospitosament tranquil.",
    "Viu i avorrit. L'ideal.",
    "Sense novetat al front.",
    "Ni fred ni calor. Perfecte.",
  ],
  "now.status.stayAware": [
    "Ull viu, que les carrega el diable.",
    "No et fiïs ni de la teva ombra.",
    "Un ull obert, per si de cas.",
    "Aquesta és la part tranquil·la. Gaudeix.",
    "No et refiïs, va.",
    "Tu vigila, no fos cas.",
  ],
  "now.status.sub.allClear": [
    "Res que vulgui matar-te al radi. Miracle.",
    "Sense perills a prop. Desconfia igual.",
    "El radi, net. De moment.",
    "Res al radar. A veure quant dura.",
    "Tot en calma. Massa calma.",
    "Res a la vista. L'univers està en una altra cosa.",
  ],
  "now.activity.empty": [
    "Sospitosament tranquil, eh.",
    "Res. Gairebé de mal gust.",
    "Això està més mort que l'agost.",
    "Ni una ànima. Grills.",
    "Zero notícies. Fem com si fos bo.",
    "Silenci. Mala espina, però silenci.",
  ],
  "onboarding.promise.tagline": "Veïns mantenint veïns sobre el terra.",
  "onboarding.promise.continue": "Sobrevivim això",
  "onboarding.home.browse": "Només curiosejant l'apocalipsi",
  "you.voice.intro": "Tria la teva varietat de males notícies.",
};
